import { ToolbarService } from './toolbar/services/toolbar.service';
import { SidebarService } from './services/sidebar.service';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LAYOUTS } from './components/layouts';
import { PARTIALS } from './components/partials';
import { SettingsModule } from '../settings/settings.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PluginsModule } from '../plugins/plugins.module';
import { SupportModule } from '../support/support.module';
import { FormsModule } from '../forms/forms.module';
import { LaddaModule } from 'angular2-ladda';
import { ErrorComponent } from './components/error/error.component';
import { ToolbarComponent } from './toolbar/components/toolbar/toolbar.component';
import { AuthenticationModule } from '../authentication/authentication.module';
import { ChassisModalModule } from '../modals/modals.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        PluginsModule,
        AuthenticationModule,
        ChassisModalModule,
        SupportModule,
        FormsModule,
        SettingsModule,
        LaddaModule
    ],
    entryComponents: [
        LAYOUTS,
        PARTIALS,
        ErrorComponent,
        ToolbarComponent
    ],
    declarations: [
        LAYOUTS,
        PARTIALS,
        ErrorComponent
    ],
    exports: [],
    providers: []
})
export class LayoutModule {

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: LayoutModule,
            providers: [ToolbarService, SidebarService]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/layout.module.ts